import React, { useState } from 'react';
import styled from 'styled-components';
import 'antd/dist/antd.css';
import { Modal } from 'antd';
import { iconSucceed } from '../../assets/images/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '../index';

import { searchIcon, chatIcon } from '../../assets/images/icons';
import { role } from '../../config/Constants';
import { ADD_NEW_EMPLOYEE, EMPLOYEE_DETAIL } from '../../routes/main';

const template = (props) => {
    const { t, i18n } = useTranslation();
    const {
        visibleModal,
        errorMessage,
        successText,
        buttonTitle,
        successSecondLine = ''
    } = props;

    return (
        <Modal
            className="ant-modal-custom"
            visible={visibleModal}
            centered
            // onOk={() => {
            //     props.onOk();
            // }}
            onCancel={() => {
                props.cancelModal();
            }}
            footer={null}
        >
            {!errorMessage ? (
                <TextSection>
                    <SuccessIcon src={iconSucceed} />
                    <SuccessText>{successText}</SuccessText>
                    {successSecondLine && (
                        <SecondSuccessLine>
                            {successSecondLine}
                        </SecondSuccessLine>
                    )}
                </TextSection>
            ) : (
                <SuccessText>{errorMessage.toUpperCase()}</SuccessText>
            )}

            <Button
                title={buttonTitle}
                backgroundColor={'#19C0FF'}
                textColor={'#FFFFFF'}
                fontSize={'13px'}
                onClick={() => {
                    props.onOk();
                }}
            />
        </Modal>
    );
};

const TextSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;
`;

const SuccessIcon = styled.img`
    width: 64px;
    height: 64px;
    margin-bottom: 25px;
`;

const SuccessText = styled.span`
    color: #121216;
    font-family: AvenirNext-DemiBold;
    font-size: 18px;
    letter-spacing: 0.8px;
    line-height: 32px;
`;

const SecondSuccessLine = styled.span`
    color: #65686f;
    font-family: AvenirNext-Medium;
    font-size: 15px;
    line-height: 26px;
`;

export { template };
